import React, { lazy, useEffect, useState } from "react";
import withLazy from './withLazy'
import doLogin from '@/utils/login'
import Home from "../pages/Home";
import OrganizationBuild from '../pages/OrganizationBuild'
import RightsService from '../pages/RightsService'
import InformationDetail from '../pages/InformationDetail'
import AdviceForm from '../pages/AdviceForm'
import SubmitStatus from '../pages/SubmitStatus'
import AdviceHistory from '../pages/AdviceHistory'
import AdviceDetail from '../pages/AdviceDetail'
import RightsServiceForm from '../pages/RightsServiceForm'
import RightsServiceSuccess from '../pages/RightsServiceSuccess'
import ApplicationIssues from '../pages/ApplicationIssues'
import WorkerService from '../pages/WorkerService'
import WorkerServiceDetail from '../pages/WorkerServiceDetail'
import CulturePalace from '../pages/CulturePalace'
import CulturePalaceDetail from '../pages/CulturePalaceDetail'
import ActivityList from '../pages/ActivityList'
import ActivityDetail from '../pages/ActivityDetail'
import WorkerMien from '../pages/WorkerMien'
import WorkerMienDetail from '../pages/WorkerMienDetail'
import PsychiatristBrief from '../pages/PsychiatristBrief'
import BeautifulWorker from '../pages/BeautifulWorker'
import InnovationWorkshop from '../pages/InnovationWorkshop'
import InternetSchool from '../pages/InternetSchool'
import PsychiatristForm from '../pages/PsychiatristForm'
import PsychiatristSuccess from '../pages/PsychiatristSuccess'
import PsychiatristHistory from '../pages/PsychiatristHistory'
import PsychiatristDetail from '../pages/PsychiatristDetail'
import BeautifulBuilder from '../pages/BeautifulBuilder'
import GiftPack from '../pages/GiftPack'
import ToAlipay from '../pages/ToAlipay'
// import NoLoign from '../pages/NoLoign'

import {
  Routes,
  Route,
} from "react-router-dom";
import { Empty } from "dingtalk-design-mobile";

const Routers = () => {
  const [isLogin, setIsLogin] = useState(false)
  const [isLoginErr, setIsLoginErr] = useState(false)
  useEffect(() => {
    localStorage.setItem('SOURCE_HREF', window.location.href)
    doLogin().then((res) => {
      if (res) {
        setIsLogin(true)
      } else {
        setIsLoginErr(true)
      }
    }).catch((e) => {
      setIsLoginErr(true)
    })
  }, [])

  if(window.location.href.indexOf("auth_code") !== -1){
    return <ToAlipay />
  }

  // if (isLogin === false) {
  //   // 无需登录页面
  //   return <Routes>
  //       <Route path="/" element={ withLazy(() => <NoLoign />) }></Route>
  //   </Routes>
  // } 
  if (isLoginErr) {
    return <Empty type="permission" inline />
  }
  return <Routes>
    {/* <Route path="/" element={withLazy(lazy(() => import('@/pages/GiftPack')))}></Route> */}
    {/* 首页 */}
    <Route path="/" element={ withLazy(() => <Home />) }></Route>

    <Route path="/InformationDetail" element={withLazy(lazy(() => import('@/pages/InformationDetail')))}></Route>
    {/* 建言献策-表单 */}
    <Route path="/AdviceForm" element={withLazy(lazy(() => import('@/pages/AdviceForm')))}></Route>
    {/* 建言献策-完成 */}
    <Route path="/SubmitStatus" element={withLazy(lazy(() => import('@/pages/SubmitStatus')))}></Route>
    {/* 建言献策-历史 */}
    <Route path="/AdviceHistory" element={withLazy(lazy(() => import('@/pages/AdviceHistory')))}></Route>
    {/* 建言献策-详情 */}
    <Route path="/AdviceDetail" element={withLazy(lazy(() => import('@/pages/AdviceDetail')))}></Route>
    {/* 组织建设-列表 */}
    <Route path="/OrganizationBuild" element={withLazy(lazy(() => import('@/pages/OrganizationBuild')))}></Route>
    {/* 维权服务-列表 */}
    <Route path="/RightsService" element={withLazy(lazy(() => import('@/pages/RightsService')))}></Route>
    {/* 维权服务-表单 */}
    <Route path="/RightsServiceForm" element={withLazy(lazy(() => import('@/pages/RightsServiceForm')))}></Route>
    {/* 维权服务-提交成功 */}
    <Route path="/RightsServiceSuccess" element={withLazy(lazy(() => import('@/pages/RightsServiceSuccess')))}></Route>
    {/* 申请事项-注意事项 */}
    <Route path="/ApplicationIssues" element={withLazy(lazy(() => import('@/pages/ApplicationIssues')))}></Route>
    {/* 维权服务-事项 */}
    <Route path="/WorkerService" element={withLazy(lazy(() => import('@/pages/WorkerService')))}></Route>
    {/* 维权服务-查看政策文件 */}
    <Route path="/WorkerServiceDetail" element={withLazy(lazy(() => import('@/pages/WorkerServiceDetail')))}></Route>
    {/* 工人文化宫-列表 */}
    <Route path="/CulturePalace" element={withLazy(lazy(() => import('@/pages/CulturePalace')))}></Route>
    {/* 工人文化宫-详情 */}
    <Route path="/CulturePalaceDetail" element={withLazy(lazy(() => import('@/pages/CulturePalaceDetail')))}></Route>
    {/* 活动互娱-列表 */}
    <Route path="/ActivityList" element={withLazy(lazy(() => import('@/pages/ActivityList')))}></Route>
    {/* 活动互娱-详情 */}
    <Route path="/ActivityDetail" element={withLazy(lazy(() => import('@/pages/ActivityDetail')))}></Route>
    {/* 职工风采-列表 */}
    <Route path="/WorkerMien" element={withLazy(lazy(() => import('@/pages/WorkerMien')))}></Route>
    {/* 职工风采-详情 */}
    <Route path="/WorkerMienDetail" element={withLazy(lazy(() => import('@/pages/WorkerMienDetail')))}></Route>
    {/* 心理咨询-列表 */}
    <Route path="/PsychiatristBrief" element={withLazy(lazy(() => import('@/pages/PsychiatristBrief')))}></Route>
    {/* 心理咨询-表单 */}
    <Route path="/PsychiatristForm" element={withLazy(lazy(() => import('@/pages/PsychiatristForm')))}></Route>
    {/* 心理咨询-提交成功 */}
    <Route path="/PsychiatristSuccess" element={withLazy(lazy(() => import('@/pages/PsychiatristSuccess')))}></Route>
    {/* 心理咨询-历史列表 */}
    <Route path="/PsychiatristHistory" element={withLazy(lazy(() => import('@/pages/PsychiatristHistory')))}></Route>
    {/* 心理咨询-详情 */}
    <Route path="/PsychiatristDetail" element={withLazy(lazy(() => import('@/pages/PsychiatristDetail')))}></Route>
    {/* 最美劳动者-详情 */}
    <Route path="/BeautifulWorker" element={withLazy(lazy(() => import('@/pages/BeautifulWorker')))}></Route>
    {/* 创新工作室-详情 */}
    <Route path="/InnovationWorkshop" element={withLazy(lazy(() => import('@/pages/InnovationWorkshop')))}></Route>
    {/* 线上学堂-详情 */}
    <Route path="/InternetSchool" element={withLazy(lazy(() => import('@/pages/InternetSchool')))}></Route>
    {/* 最美建设者-列表 */}
    <Route path="/BeautifulBuilder" element={withLazy(lazy(() => import('@/pages/BeautifulBuilder')))}></Route>
    {/* 选礼包 */}
    <Route path="/GiftPack" element={withLazy(lazy(() => import('@/pages/GiftPack')))}></Route>

    <Route path="/Test" element={withLazy(lazy(() => import('@/pages/Test')))}></Route>



    {/* <Route path="/" element={withLazy(lazy(() => import('@/pages/App')))}></Route> */}
  </Routes>
}

export default Routers
